import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import CHECKBOX from './checkbox.palette-schema.yaml';

registerTileSchema(CHECKBOX);

export const CHECKBOX_TYPES = {
    VERTICAL: 'VERTICAL',
    HORIZONTAL: 'HORIZONTAL',
};

const CONTAINER_STYLES = {
    [CHECKBOX_TYPES.HORIZONTAL]: {
        flexDirection: 'row',
    },
    [CHECKBOX_TYPES.VERTICAL]: {
        flexDirection: 'column',
    },
};

const DEFAULT_TYPE = CHECKBOX_TYPES.HORIZONTAL;

export function generateCheckbox(TILE, TYPE = DEFAULT_TYPE) {
    const CONTAINER_STYLE = CONTAINER_STYLES[TYPE] || CONTAINER_STYLES[DEFAULT_TYPE];

    return {
        container: {
            style: {
                base: {
                    ...CONTAINER_STYLE,
                    padding: 0,
                    minWidth: 0,
                    minHeight: 'initial',
                    margin: '0 16px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0 8px',
                },
                disabled: {
                    opacity: 0.3,
                    //todo: it's will be good to make here own stiles for disabled state (look at northstar design)
                },
            },
        },
        checkButtonImageContainer: {
            style: {
                borderWidth: 1,
                borderRadius: TILE.CHECKBOX_BORDER_RADIUS,
                borderColor: TILE.CHECKBOX_BORDER_COLOR,
                borderStyle: 'solid',
                boxSizing: 'border-box',
                ...resolveBackground(TILE.CHECKBOX_BG), // Moj bug, need to use resolveBackground
            },
        },
        label: {
            style: {
                textAlign: 'center',
                ...TILE.CHECKBOX_LABEL,
            },
        },
        icon: icon(TILE.CHECKBOX_ICON_COLOR),
    };
}
